<template>
  <div>
    <div class="user-forget-body-content-msg">
      <img src="../../../static/img/forget_success.png" alt="">
      <div class="message" v-html="message"></div>
    </div>
    <router-link to="'/login'" class="link-login-a">立即登录</router-link>
  </div>
</template>

<script>
import setting from '../../settings.js'

export default {
  name: 'ForgetSuccess',
  data () {
    return {
      message: '重置密码成功，系统会将密码发到您的邮箱</br>请注意查收邮箱。',
      setting: setting
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  }
}
</script>
<style lang="less" scoped>
  .user-forget {
    background-color: #F6F5FA;
    &-body {
      display: flex;
      height: calc(100vh - 5rem);
      align-items: center;
      .user-forget-body-content {
        width: 80vw;
        max-width: 45rem;
        margin: 0 auto;
        padding: 3.4rem 5.5rem;
        font-size: 1rem;
        background-color: #ffffff;
        box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.13);
        border-radius: 12px;
        &-title {
          margin-bottom: 3rem;
          color: #272727;
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 1;
        }
        /deep/ .ant-divider-horizontal {
          margin: 0 0 1.7rem 0;
        }
        &-msg {
          display: flex;
          margin-bottom: 3rem;
          align-items: center;
          img {
            width: 3.8rem;
            height: 3.8rem;
            margin-right: 1rem;
          }
          .message {
            color: #272727;
            font-size: .9rem;
            font-weight: 500;
            line-height: 1.5rem;
          }
        }
      }
      .link-login-a {
        display: inline-block;
        width: 9.25rem;
        height: 2.2rem;
        margin-left: 4.8rem;
        color: #FFFFFF;
        font-size: .9rem;
        background-color: #5C86E5;
        border-radius: .2rem;
        text-align: center;
        line-height: 2.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ForgetSuccess.vue?5a3c9258